import React from 'react';

export const NotFound = () => (
    <h2 className="title">Page not found 404</h2>
)